import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const TextDraggable = () => {
  const id = v4()
  const type = FormItemType.Input

  return (
    <FormItemDraggableBase
      icon={IconEnum.Text}
      id={id}
      title="formBuilder.textField"
      type={type}
    />
  )
}
